import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const ForgotPasswordAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "forgot-password" */ './forgot-password'),
  componentName: 'ForgotPassword',
});
